export default "__VITE_ASSET__B3W_4Y1K__"